var React = require('react');

function IcoPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"iwh","d":"M46.5,0.4C20.9,0.4,0,21.2,0,46.9c0,25.6,20.9,46.5,46.5,46.5S93,72.5,93,46.9\n      C93,21.2,72.1,0.4,46.5,0.4z M46.5,6.6c22.3,0,40.3,18,40.3,40.3s-18,40.3-40.3,40.3S6.2,69.1,6.2,46.9S24.2,6.6,46.5,6.6z\n      M41.7,38v19.4l16.5-9.7L41.7,38z"}));
}

IcoPlay.defaultProps = {"viewBox":"0 0 93 94","id":"playic","width":"93px","height":"94px"};

module.exports = IcoPlay;

IcoPlay.default = IcoPlay;
